/* src/pages/companytypes/page-company-types.component.scss */
:host {
  display: block;
}
.company-type-col--actions {
  width: 120px;
}
/*# sourceMappingURL=page-company-types.component-YGSWSSB3.css.map */
